import { currentLang } from '@/composables/settings/storage'

//分享类的interface
interface ShareBase {
  shareCardTitle: string
  shareCardImgUrl: string
  shareUrl: string
  pageTitle: string
  url: string
}

abstract class Post implements ShareBase, UserBase {
  // ShareBase 属性
  shareCardTitle!: string
  shareCardImgUrl!: string
  shareUrl!: string
  pageTitle!: string
  url!: string

  // UserBase 属性
  userAvatarUrl!: string
  userName!: string
  userRelation!: string
  publishDate!: string

  // Post 自有属性
  contentTitle!: string
}
interface UserBase {
  userAvatarUrl: string
  userName: string
  userRelation: string
  publishDate: string
}
export interface Brick {
  type: string // 1:标题  2:文本   3:图片   4:视频    5 用户信息

  style?: string | null //当 type为1/2/3/4时，style为样式，当 type为5时，style为空
  content?: string | null //当 type为1/2/3/4时，content为内容，当 type为5时，content为空

  userAvatarUrl?: string | null //当 type为5时，userAvatarUrl为头像
  userName?: string | null //当 type为5时，userName为名字
  userRelation?: string | null //当 type为5时，userRelation为关系
  publishDate?: string | null //当 type为5时，publishDate为日期
}

const separator = '!~!'

const brickSeparator = '~!!!~'

// 图文类型 (默认分享  / 讣告分享) type:1
export class imageTextShare implements ShareBase {
  shareCardTitle: string
  shareCardImgUrl: string

  shareUrl: string
  pageTitle: string
  contentTitle: string

  brick: Brick[]

  url: string

  constructor(
    shareCardTitle: string,
    shareCardImgUrl: string,
    shareUrl: string,
    pageTitle: string,
    contentTitle: string,
    brick: Brick[]
  ) {
    this.shareCardTitle = shareCardTitle
    this.shareCardImgUrl = shareCardImgUrl
    this.shareUrl = shareUrl
    this.pageTitle = pageTitle
    this.contentTitle = contentTitle
    this.brick = brick
    this.url = this.createShareUrl()
  }

  private createShareUrl(): string {
    let url = `/pages/share/share?common=${encodeURIComponent(this.pageTitle)}${separator}${encodeURIComponent(
      this.shareUrl
    )}${separator}${encodeURIComponent(this.shareCardTitle)}${separator}${encodeURIComponent(
      this.shareCardImgUrl
    )}${separator}${encodeURIComponent(currentLang.value as string)}${separator}${encodeURIComponent(
      this.contentTitle
    )}`
    url += `&brick=`
    this.brick.forEach((item, index) => {
      if (item.type === '5') {
        url += `${encodeURIComponent(item.type)}${separator}${encodeURIComponent(item.userAvatarUrl || '')}${separator}${encodeURIComponent(item.userName || '')}${separator}${encodeURIComponent(
          item.userRelation || ''
        )}${separator}${encodeURIComponent(item.publishDate || '')}${index === this.brick.length - 1 ? '' : brickSeparator}`
      } else {
        if (item.content && item.content?.length > 120 && item.type == '2') {
          item.content = item.content?.slice(0, 120) + '...'
        } else if (item.content && item.content?.length > 20 && item.type == '1') {
          item.content = item.content?.slice(0, 20) + '...'
        }
        url += `${encodeURIComponent(item.type)}${separator}${encodeURIComponent(item.style || '')}${separator}${encodeURIComponent(item.content || '')}${
          index === this.brick.length - 1 ? '' : brickSeparator
        }`
      }
    })
    return url
  }
}

export class InvitationShare implements ShareBase {
  shareCardTitle: string
  shareCardImgUrl: string
  shareUrl: string
  pageTitle: string
  url: string

  avatarUrl: string
  name: string // xxx的纪念
  range: string // 1900-1987
  content: string // 张纯恺邀请您参加张纯如的纪念
  BGUrl: string

  constructor(
    shareCardTitle: string,
    shareCardImgUrl: string,
    shareUrl: string,
    pageTitle: string,
    avatarUrl: string,
    name: string,
    range: string,
    content: string,
    sharePageBGImageUrl: string
  ) {
    this.shareCardTitle = shareCardTitle
    this.shareCardImgUrl = shareCardImgUrl
    this.shareUrl = shareUrl
    this.pageTitle = pageTitle

    this.avatarUrl = avatarUrl
    this.name = name
    this.range = range
    this.content = content
    this.BGUrl = sharePageBGImageUrl

    this.url = this.createShareUrl()
  }

  private createShareUrl(): string {
    // 首先拼接通用参数
    let url = `/pages/share/share?common=${encodeURIComponent(this.pageTitle)}${separator}${encodeURIComponent(
      this.shareUrl
    )}${separator}${encodeURIComponent(this.shareCardTitle)}${separator}${encodeURIComponent(
      this.shareCardImgUrl
    )}${separator}${encodeURIComponent(currentLang.value as string)}`
    url += `&invitation=${encodeURIComponent(this.avatarUrl)}${separator}${encodeURIComponent(this.name)}${separator}${encodeURIComponent(this.range)}${separator}${encodeURIComponent(this.content)}${separator}${encodeURIComponent(this.BGUrl)}`
    return url
  }
}

/**
 * 必须要包含的参数，通用参数： 
 * 1. pageTitle
 * 2. shareUrl
 * 3. shareCardTitle
 * 4. shareCardImgUrl
 * 5. lang
 * 最后拼接的字符串： ?common=(pageTitle)(separator)(shareUrl)(separator)(shareCardTitle)(separator)(shareCardImgUrl)(separator)(lang)
 * 
 * 
 * 积木参数
 * string组成
 * type 1:标题  2:文本   3:图片   4:视频    5 用户信息
 * (separator)
 * style  1:h1-h4    2:
 * content 内容 / url
 * ~!!!~
 * 最后拼接的字符串： &brick=(type)(separator)(style)(separator)(content)~!!!~(type)(separator)(style)(separator)(content)
 * 
 * 
 * 
 * 邀请函
 *  avatarUrl: string;
  name: string; // xxx的纪念
  range: string; // 1900-1987
  content: string; // 张纯恺邀请您参加张纯如的纪念
  BGUrl: string;
 * 最后拼接的字符串： &invitation=(avatarUrl)(separator)(name)(separator)(range)(separator)(content)(separator)(BGUrl)
 */

//
